export default {
  methods: {
    extractConfirmSubtitleByStake (activeStake) {
      let result = []
      let stakeEnum = activeStake.StakeEnum
      let stakeTypeEnum = activeStake.StakeTypeEnum
      if (stakeTypeEnum >= 7 && stakeTypeEnum <= 10) {
        switch (stakeTypeEnum) {
          case 7:
            result.push({ 'title': stakeEnum === 1 ? 'vdog_log_hiw_0' : 'vdog_log_hiw_1', 'subtitle': '' })
            break
          case 8:
            result.push({ 'title': stakeEnum === 1 ? 'vdog_odd_event_0' : 'vdog_odd_event_1', 'subtitle': '' })
            break
          case 9:
            result.push({ 'title': stakeEnum === 1 ? 'vdog_sum_1_2_0' : 'vdog_sum_1_2_1', 'subtitle': '' })
            break
          case 10:
            result.push({ 'title': stakeEnum === 1 ? 'vdog_sum_1_2_3_0' : 'vdog_sum_1_2_3_1', 'subtitle': '' })
            break
        }
      } else {
        if (stakeEnum < 10) {
          result.push({ 'title': 'vdog', 'subtitle': stakeEnum })
        } else if (stakeEnum < 100) {
          result.push({ 'title': 'vdog', 'subtitle': Math.floor(stakeEnum / 10) })
          result.push({ 'title': 'vdog', 'subtitle': stakeEnum % 10 })
        } else if (stakeEnum < 1000) {
          result.push({ 'title': 'vdog', 'subtitle': Math.floor(stakeEnum / 100) })
          result.push({ 'title': 'vdog', 'subtitle': Math.floor(stakeEnum % 100 / 10) })
          result.push({ 'title': 'vdog', 'subtitle': stakeEnum % 10 })
        }
      }
      return result
    },
    getPreparedDataFromMatch (data, isPrevious) {
      return {
        roundNo: isPrevious ? data.PreviousRoundNo : data.RoundNo,
        activeStake: null,
        trifectaTable: {
          title: 'vdog_trifecta',
          header: [
            { 'title': 'vdog_1', 'class': 'a-vg-c--on one' },
            { 'title': 'vdog_2', 'class': 'a-vg-c--on two' },
            { 'title': 'vdog_3', 'class': 'a-vg-c--on three' },
            { 'title': 'vdog_4', 'class': 'a-vg-c--on four' },
            { 'title': 'vdog_5', 'class': 'a-vg-c--on five' },
            { 'title': 'vdog_6', 'class': 'a-vg-c--on six' }
          ],
          sideItems: [
            { 'title': 'vdog_first_trifecta', 'class': 'place' },
            { 'title': 'vdog_second_trifecta', 'class': 'place' },
            { 'title': 'vdog_third_trifecta', 'class': 'place' }
          ],
          data: [
            [{ 'id': '1', 'Factor': 1 }, { 'id': '', 'Factor': 2 }, { 'id': '4', 'Factor': 3 }, { 'id': '7', 'Factor': 4 }, { 'id': '10', 'Factor': 5 }, { 'id': '13', 'Factor': 6 }],
            [{ 'id': '2', 'Factor': 1 }, { 'id': '', 'Factor': 2 }, { 'id': '5', 'Factor': 3 }, { 'id': '8', 'Factor': 4 }, { 'id': '11', 'Factor': 5 }, { 'id': '14', 'Factor': 6 }],
            [{ 'id': '3', 'Factor': 1 }, { 'id': '', 'Factor': 2 }, { 'id': '6', 'Factor': 3 }, { 'id': '9', 'Factor': 4 }, { 'id': '12', 'Factor': 5 }, { 'id': '15', 'Factor': 6 }]
          ],
          stakesData: data.Data.trifectaTable
        },
        winnerInFirstTable: {
          title: 'vdog_winner_in_first',
          header: [
            { 'title': 'vdog_winner', 'class': 'top-field top-field--success' },
            { 'title': 'vdog_in_first_2', 'class': 'top-field top-field--success' },
            { 'title': 'vdog_in_first_3', 'class': 'top-field top-field--success' },
            { 'title': 'vdog_not_a_winner', 'class': 'top-field top-field--neutral' },
            { 'title': 'vdog_not_in_first_2', 'class': 'top-field top-field--neutral' },
            { 'title': 'vdog_not_in_first_3', 'class': 'top-field top-field--neutral' }
          ],
          sideItems: [
            { 'title': 'vdog_1', 'class': 'a-vg-c--on one' },
            { 'title': 'vdog_2', 'class': 'a-vg-c--on two' },
            { 'title': 'vdog_3', 'class': 'a-vg-c--on three' },
            { 'title': 'vdog_4', 'class': 'a-vg-c--on four' },
            { 'title': 'vdog_5', 'class': 'a-vg-c--on five' },
            { 'title': 'vdog_6', 'class': 'a-vg-c--on six' }
          ],
          data: data.Data.winingTable
        },
        combinationBettingTable: {
          title: 'vdog_combination_betting',
          header: [
            { 'title': 'vdog_1', 'class': 'a-vg-c--on one' },
            { 'title': 'vdog_2', 'class': 'a-vg-c--on two' },
            { 'title': 'vdog_3', 'class': 'a-vg-c--on three' },
            { 'title': 'vdog_4', 'class': 'a-vg-c--on four' },
            { 'title': 'vdog_5', 'class': 'a-vg-c--on five' },
            { 'title': 'vdog_6', 'class': 'a-vg-c--on six' }
          ],
          sideItems: [
            { 'title': 'vdog_1', 'class': 'a-vg-c--on one' },
            { 'title': 'vdog_2', 'class': 'a-vg-c--on two' },
            { 'title': 'vdog_3', 'class': 'a-vg-c--on three' },
            { 'title': 'vdog_4', 'class': 'a-vg-c--on four' },
            { 'title': 'vdog_5', 'class': 'a-vg-c--on five' },
            { 'title': 'vdog_6', 'class': 'a-vg-c--on six' }
          ],
          data: data.Data.combinationTable
        },
        doubleChanceTable: {
          title: 'vdog_double_chance',
          header: [
            { 'title': 'vdog_1', 'class': 'a-vg-c--on one' },
            { 'title': 'vdog_2', 'class': 'a-vg-c--on two' },
            { 'title': 'vdog_3', 'class': 'a-vg-c--on three' },
            { 'title': 'vdog_4', 'class': 'a-vg-c--on four' },
            { 'title': 'vdog_5', 'class': 'a-vg-c--on five' },
            { 'title': 'vdog_6', 'class': 'a-vg-c--on six' }
          ],
          sideItems: [
            { 'title': 'vdog_1', 'class': 'a-vg-c--on one' },
            { 'title': 'vdog_2', 'class': 'a-vg-c--on two' },
            { 'title': 'vdog_3', 'class': 'a-vg-c--on three' },
            { 'title': 'vdog_4', 'class': 'a-vg-c--on four' },
            { 'title': 'vdog_5', 'class': 'a-vg-c--on five' },
            { 'title': 'vdog_6', 'class': 'a-vg-c--on six' }
          ],
          data: data.Data.doubleChangeTable
        },
        sumTable12: {
          title: 'vdog_sum_1_2',
          header: [{ 'title': 'vdog_sum_1_2_0', 'class': '' }, { 'title': 'vdog_sum_1_2_1', 'class': '' }],
          data: data.Data.sum12Table
        },
        sumTable123: {
          title: 'vdog_sum_1_2_3',
          header: [{ 'title': 'vdog_sum_1_2_3_0', 'class': '' }, { 'title': 'vdog_sum_1_2_3_1', 'class': '' }],
          data: data.Data.sum123Table
        },
        tableLowHigh: {
          title: 'vdog_low_high',
          header: [{ 'title': 'vdog_log_hiw_0', 'class': '' }, { 'title': 'vdog_log_hiw_1', 'class': '' }],
          data: data.Data.lowHighTable
        },
        tableOddEven: {
          title: 'vdog_odd_even',
          header: [{ 'title': 'vdog_odd_event_0', 'class': '' }, { 'title': 'vdog_odd_event_1', 'class': '' }],
          data: data.Data.oddEvenTable
        }
      }
    },
    getPreparedDataJackpot (data) {
      let fallenJackpots = {
        'showSlider': '',
        'ticketNo': '',
        'ticketLocation': '',
        'JackpotAmount': ''
      }
      let showFallenJackpots = false
      if (data) {
        if (data.JackpotName.includes('local') || data.JackpotName.includes('Local')) {
          fallenJackpots.showSlider = 'Local'
        } else if (data.JackpotName.includes('super') || data.JackpotName.includes('Super')) {
          fallenJackpots.showSlider = 'Super'
        }
        fallenJackpots.ticketNo = data.Barcode
        fallenJackpots.ticketLocation = data.LocationName
        fallenJackpots.jackpotAmount = data.JackpotAmount
        showFallenJackpots = true
      }
      return {
        'fallenJackpots': fallenJackpots,
        'showFallenJackpots': showFallenJackpots
      }
    },
    inputClass (selected, status) {
      if (selected === '3') {
        if (status === 0) return 'danger'
        if (status === 1) return 'success'
        if (status === 2) return 'neutral'
      } else if (selected === '0') {
        if (status === 0) return 'danger'
        if (status === 1) return 'hide'
        if (status === 2) return 'hide'
      } else if (selected === '1') {
        if (status === 0) return 'hide'
        if (status === 1) return 'success'
        if (status === 2) return 'hide'
      } else if (selected === '2') {
        if (status === 0) return 'hide'
        if (status === 1) return 'hide'
        if (status === 2) return 'neutral'
      }
    },
    extractClassForDogPosition (position) {
      switch (position) {
        case 0: return 'one'
        case 1: return 'two'
        case 2: return 'three'
        case 3: return 'four'
        case 4: return 'five'
        case 5: return 'six'
      }
      return ''
    },
    awardImage (place) {
      switch (place) {
        case 1: return this.loadImageByName('gold')
        case 2: return this.loadImageByName('silver')
        case 3: return this.loadImageByName('bronze')
      }
    },
    loadImageByName (name) {
      switch (name) {
        case 'gold': return 'https://cloud.aleacontrol.com/media/vDogs/gold.png'
        case 'silver': return 'https://cloud.aleacontrol.com/media/vDogs/silver.png'
        case 'bronze': return 'https://cloud.aleacontrol.com/media/vDogs/bronze.png'
      }
    },
    awardAltTag (place) {
      switch (place) {
        case 1: return 'first'
        case 2: return 'secound'
        case 3: return 'third'
      }
    }
  }
}
